'use client';

const FacetSkeleton = () => {
  return <div className='flex flex-col' data-sentry-component="FacetSkeleton" data-sentry-source-file="facet-skeleton.tsx">
            <span className='hidden py-3 text-body-14 text-text-darkGray lg:block'>فیلترها</span>
            <div className='h-[931px] w-full animate-pulse rounded bg-gray-100' />
        </div>;
};
export default FacetSkeleton;